import { createMachine, state, transition, reduce, invoke } from "robot3";
import { wpFetchRestApi, isWpSuccess, logCtxAndEv } from "../util";
import { useMachine } from "svelte-robot-factory";
import { setSelectedDay, setCalendar } from "./store";
import { get } from "svelte/store";
;
const selectDayWithEffects = (ctx, ev) => {
    setSelectedDay(ev.data.day);
    return ctx;
};
const storeCalendarWithEffects = (ctx, ev) => {
    setCalendar(ev.data);
    return ctx;
};
const storeSurroundingMonths = (ctx, ev) => (Object.assign(Object.assign({}, ctx), { currentMonth: ev.data.month.month, nextMonth: ev.data.month.next_month, previousMonth: ev.data.month.previous_month }));
const clearError = (ctx) => (Object.assign(Object.assign({}, ctx), { error: undefined }));
const storeError = (ctx, ev) => (Object.assign(Object.assign({}, ctx), { error: ev.error }));
const loadNextMonth = (ctx) => (Object.assign(Object.assign({}, ctx), { monthToFetch: ctx.nextMonth }));
const loadPreviousMonth = (ctx) => (Object.assign(Object.assign({}, ctx), { monthToFetch: ctx.previousMonth }));
const loadCurrentMonth = (ctx) => (Object.assign(Object.assign({}, ctx), { monthToFetch: ctx.currentMonth }));
const EVT_SELECT_DAY = "select_day";
const machine = createMachine({
    not_initialized: state(transition('initialize', 'viewing', reduce(storeSurroundingMonths))),
    viewing: state(transition(EVT_SELECT_DAY, 'viewing', reduce(selectDayWithEffects), reduce(logCtxAndEv('Day selected'))), transition('next_month', 'fetching_month', reduce(loadNextMonth)), transition('previous_month', 'fetching_month', reduce(loadPreviousMonth)), transition('current_month', 'fetching_month', reduce(loadCurrentMonth))),
    fetching_month: invoke(fetchCalendar, transition('done', 'viewing', reduce(storeSurroundingMonths), reduce(storeCalendarWithEffects), reduce(clearError)), transition('error', 'viewing', reduce(storeError))),
}, (ctx) => ctx);
async function fetchCalendar(ctx) {
    const endpoint = 'calendar/' + ctx.monthToFetch;
    const result = await wpFetchRestApi(endpoint, 'GET');
    if (!isWpSuccess(result)) {
        throw new Error(result.message);
    }
    return result.data;
}
const initialContext = {
    currentMonth: 0,
    nextMonth: 0,
    previousMonth: 0,
};
export const service = useMachine(machine, initialContext);
export const createSelectDayEvent = (day) => ({
    type: EVT_SELECT_DAY,
    data: {
        day: day,
    }
});
export const initialize = (calendar) => {
    const s = get(service);
    const ev = {
        type: 'initialize',
        data: calendar,
    };
    s.send(ev);
};
